import { BOTTOM_FEATURES } from '../../../constants/homeData';
import iconOffline from '../../../assets/images/feature-icon-offline.png';
import iconLive from '../../../assets/images/feature-icon-live.png';
import iconDoubt from '../../../assets/images/feature-icon-doubt.png';
import iconProgress from '../../../assets/images/feature-icon-progress.png';

const FEATURE_ICONS = {
  offline: { src: iconOffline, alt: 'Offline Download' },
  live: { src: iconLive, alt: 'Live Class' },
  doubt: { src: iconDoubt, alt: 'Doubt Clearing' },
  progress: { src: iconProgress, alt: 'Progress Tracking' },
};

function FeatureIcon({ id }) {
  const icon = FEATURE_ICONS[id];
  if (!icon) return null;

  return (
    <img
      src={icon.src}
      alt={icon.alt}
      className="h-8 w-8 shrink-0 object-contain sm:h-9 sm:w-9"
    />
  );
}

function FeatureBar() {
  return (
    <div className="w-full bg-gradient-to-r from-[#EBDCFD] via-[#CFB3FF] to-[#F2E7FE] px-4 py-4 sm:px-8 lg:px-10 xl:px-16">
      <ul className="flex w-full flex-wrap items-center justify-center gap-4 sm:gap-6 lg:gap-8">
        {BOTTOM_FEATURES.map((feature) => (
          <li key={feature.id} className="flex items-center gap-3 sm:gap-4">
            <FeatureIcon id={feature.id} />
            <span className="text-base font-medium text-[#1B1B1B] lg:text-lg xl:text-[20px]">{feature.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FeatureBar;
